<script setup lang="ts">
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import { Icon } from '@iconify/vue'
import { computed, ref, watch } from 'vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  selected: {
    type: Object,
    default: () => ({}),
  },
  renameObj: {
    type: Object,
    default: () => ({}),
  },
})

const _selected = computed(() => {
  if (props.item.path) {
    return props.selected.path === props.item.path
  }
  return false
})

const _renameObj = ref(props.renameObj)

const emit = defineEmits(['click', 'dbclick', 'contextmenu', 'rename-success'])

const handleClick = (event: MouseEvent) => {
  // console.log('click', event)
  emit('click', event, props.item)
}
const handleDbClick = (event: MouseEvent) => {
  // console.log('dbclick', event)
  emit('dbclick', event, props.item)
}
const handleContext = (event: MouseEvent) => {
  // console.log('context', event)
  emit('contextmenu', event, props.item)
}

const handleRename = () => {
  handleProcessRename(_renameObj.value)
}

const handleProcessRename = async (data: any) => {
  try {
    await APIClient.post('file-management/rename', {
      path: data.path,
      newName: data.name,
    })

    emit('rename-success')
  } catch (error) {
    console.error('Rename failed:', error)
  }
}

watch(
  () => props.renameObj,
  (newVal) => {
    if (newVal.name) {
      _renameObj.value = newVal
    } else {
      _renameObj.value = {}
    }
  },
  { deep: true, immediate: true },
)

watch(
  () => _selected.value,
  (newVal) => {
    if (_renameObj.value.name) {
      handleProcessRename(_renameObj.value)
    }
    _renameObj.value = {}
  },
  { deep: true, immediate: true },
)
</script>

<template>
  <div
    :class="`folder-item ${_selected ? 'selected' : ''}`"
    @click="handleClick"
    @dblclick="handleDbClick"
    @contextmenu.prevent="handleContext"
  >
    <div class="folder-preview">
      <span>
        <Icon icon="flat-color-icons:folder" />
      </span>
    </div>
    <div class="folder-caption">
      <input
        v-if="_renameObj?.name && _renameObj?.path === props.item.path"
        v-model="_renameObj.name"
        @keydown.enter="handleRename"
      />
      <span v-else>{{ props.item.name }}</span>
    </div>
  </div>
</template>

<style scoped></style>
